import React, { useEffect } from "react";
import RootLayout from "./components/RootLayout";
import MaatwerkLayout from "./components/maatwerk/MaatwerkLayout";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Auth0Provider } from "@auth0/auth0-react";
import { createTheme } from "@mui/material";
import "@fontsource/lato";
import "@fontsource/figtree";
import { CssBaseline } from "@mui/material";
import MijnChecks from "./pages/MijnChecks";
import NieuweCheck from "./pages/NieuweCheck";
import NieuweCheckWH from "./pages/NieuweCheckWH";
import NieuweCheckWK from "./pages/NieuweCheckWK";
import NieuweCheckArbeid from "./pages/NieuweCheckArbeid";
import NieuweCheckOccasionAuto from "./pages/OccasionAuto/NieuweCheckOccasionAuto";
import Callback from "./pages/Callback";
import Klantenservice from "./pages/KlantenService";
import Account from "./pages/Account";
import Resultaten from "./pages/Resultaten";
import EmailNotVerified from "./pages/EmailNotVerified";
import "@fontsource/figtree/300.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/figtree/800.css";
import "./App.css";
import NieuweCheckAS from "./pages/AbonnementSportschool/NieuweCheckAS";
import Voorwaardengids from "./pages/Voorwaardengids";
import MaatwerkUpload from "./components/maatwerk/purchase-contract/MaatwerkUpload";
import MaatwerkUploadRental from "./components/maatwerk/rental-contract/MaatwerkUploadRental";
import MaatwerkIntro from "./components/maatwerk/MaatwerkIntro";
import MaatwerkResultaten from "./components/maatwerk/MaatwerkResultaten";
import MaatwerkQuestionnaire from "./components/maatwerk/MaatwerkQuestionnaire";
import DemoLayout from "./components/demo/DemoLayout";
import DemoHome from "./components/demo/DemoHome";
import DemoIntroKoop from "./components/demo/DemoIntroKoop";
import DemoIntroHuur from "./components/demo/DemoIntroHuur";
import DemoUploadKoop from "./components/demo/DemoUploadKoop";
import DemoUploadHuur from "./components/demo/DemoUploadHuur";
import DemoResultaten from "./components/demo/DemoResultaten";
import WelocateListings from "./components/welocate/WelocateListings";
import CheckinForm from "./components/welocate/CheckinForm";
import RoomForm from "./components/welocate/RoomForm";
import MeterForm from "./components/welocate/MeterForm";

const REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;

// Auth0-configuratie
// const AUTH0_DOMAIN = "dev-fxf5jxgmrowrkemd.eu.auth0.com";
const AUTH0_DOMAIN = "auth.checkyourterms.com";
const AUTH0_CLIENT_ID = REACT_APP_AUTH0_CLIENT_ID;

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#439BD9",
    },
    secondary: {
      main: "#E27C00",
    },
    tertiary: {
      main: "#DCEDFA",
    },
    error: {
      main: "#FF3333",
    },
    warning: {
      main: "#ffcc00",
    },
    success: {
      main: "#33cc33",
    },
    background: {
      default: "#ebebeb",
      paper: "#ebebeb",
    },
  },
  shadows: {
    0: "0px 0px 0px",
    1: "0px 0px 5px 2px rgba(0, 0, 0, 0.15)",
    4: "",
    8: "",
    24: "",
  },

  typography: {
    fontFamily: "Figtree",
    body1: {
      fontFamily: "Figtree",
      fontWeight: 300,
      fontSize: "12px",
    },
    h1: {
      fontFamily: "Figtree",
      color: "#062840",
      fontWeight: 800,
      fontSize: "56px",
      lineHeight: "136%",
    },
    h2: { fontFamily: "Figtree", color: "#2D2D2D" },
    h3: {
      fontFamily: "Figtree",
      color: "#0F3A58",
      fontWeight: 700,
      fontSize: "32px",
      lineHeight: "180%",
    },
    h4: {
      fontFamily: "Figtree",
      color: "#0F3A58",
      fontWeight: 700,
      fontSize: "28px",
      lineHeight: "120%",
    },
    h5: {
      fontFamily: "Figtree",
      color: "#0F3A58",
      fontWeight: 500,
      fontSize: "24px",
    },
    h6: {
      fontFamily: "Figtree",
      color: "#032B4A",
      fontWeight: 400,
      fontSize: "16px",
    },
  },
  breakpoints: {
    values: {
      mobile: 0,
      ipad: 650,
      laptop: 1080,
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    id: "root",
    errorElement: <div>Something went wrong</div>,
    children: [
      {
        path: "/",
        element: <MijnChecks />,
      },
      {
        path: "/modules",
        element: <NieuweCheck />,
      },
      {
        path: "/customer-service",
        element: <Klantenservice />,
      },
      {
        path: "/new-check",
        element: <NieuweCheck />,
      },
      {
        path: "/new-check/housing/rent",
        element: <NieuweCheckWH />,
      },
      {
        path: "/new-check/housing/buy",
        element: <NieuweCheckWK />,
      },
      {
        path: "/new-check/housing/student_rent",
        element: <NieuweCheckWH />,
      },
      {
        path: "/new-check/career/labour-contract",
        element: <NieuweCheckArbeid />,
      },
      {
        path: "/new-check/transport/car-occasion",
        element: <NieuweCheckOccasionAuto />,
      },
      {
        path: "/new-check/leisure-and-sports/gym-contract",
        element: <NieuweCheckAS />,
      },
      {
        path: "/voorwaardengids",
        element: <Voorwaardengids />,
      },
      {
        path: "/account-settings",
        element: <Account />,
      },
      {
        path: "/results/:moduleId/:runId",
        element: <Resultaten />,
      },
    ],
  },
  {
    path: "/callback",
    element: <Callback />,
  },
  {
    path: "/email-not-verified",
    element: <EmailNotVerified />,
  },
]);

const WL_FONT = '"Nunito", "Inter", ui-sans-serif, system-ui, -apple-system, sans-serif';

const welocateTheme = createTheme({
  ...theme,
  typography: {
    ...theme.typography,
    fontFamily: WL_FONT,
    fontWeightRegular: 400,
    body1: { ...theme.typography.body1, fontFamily: WL_FONT, fontWeight: 400 },
    h1: { ...theme.typography.h1, fontFamily: WL_FONT, fontWeight: 400 },
    h2: { ...theme.typography.h2, fontFamily: WL_FONT, fontWeight: 400 },
    h3: { ...theme.typography.h3, fontFamily: WL_FONT, fontWeight: 400 },
    h4: { ...theme.typography.h4, fontFamily: WL_FONT, fontWeight: 400 },
    h5: { ...theme.typography.h5, fontFamily: WL_FONT, fontWeight: 400 },
    h6: { ...theme.typography.h6, fontFamily: WL_FONT, fontWeight: 400 },
  },
});

// Check if we're on the maatwerk subdomain
const isMaatwerkSubdomain =
  window.location.hostname === "maatwerk.checkyourterms.com" ||
  window.location.hostname === "maatwerk.localhost";

const isWelocateSubdomain =
  window.location.hostname === "welocate.checkyourterms.com" ||
  window.location.hostname === "welocate.localhost";

const isDemoSubdomain =
  window.location.hostname === "demo.checkyourterms.com" ||
  window.location.hostname === "demo.localhost";

// Router for maatwerk subdomain
const demoRouter = createBrowserRouter([
  {
    path: "/",
    element: <DemoLayout />,
    children: [
      {
        path: "/",
        element: <DemoHome />,
      },
      {
        path: "/koopakte",
        element: <DemoIntroKoop />,
      },
      {
        path: "/koopakte/upload",
        element: <DemoUploadKoop />,
      },
      {
        path: "/koopakte/results/:requestId",
        element: <DemoResultaten />,
      },
      // {
      //   path: "/koopakte/questionnaire/:referenceId",
      //   element: <MaatwerkQuestionnaire />,
      // },
      {
        path: "/huurovereenkomst",
        element: <DemoIntroHuur />,
      },
      {
        path: "/huurovereenkomst/upload",
        element: <DemoUploadHuur />,
      },
      {
        path: "/huurovereenkomst/results/:requestId",
        element: <DemoResultaten />,
      },
      // {
      //   path: "/huurovereenkomst/questionnaire/:referenceId",
      //   element: <MaatwerkQuestionnaire />,
      // },
    ],
  },
]);

const welocateRouter = createBrowserRouter([
  {
    path: "/rental",
    element: <MaatwerkLayout company="WELOCATE" />,
    children: [
      {
        index: true,
        element: <MaatwerkIntro module="RENTAL" />,
      },
      {
        path: "upload",
        element: <MaatwerkUploadRental />,
      },
      {
        path: "results/:requestId",
        element: <MaatwerkResultaten />,
      },
      {
        path: "questionnaire/:referenceId",
        element: <MaatwerkQuestionnaire />,
      },


    ],
  },
  {
    path: "/listings-demo",
    element: <WelocateListings />,
  },
  {
    path: "checkin/:cfid",
    element: <CheckinForm />
  },
  {
    path: "checkin/:cfid/meters",
    element: <MeterForm />,
  },
  {
    path: "checkin/:cfid/rooms/:roomId",
    element: <RoomForm />
  },
]);

// Router for maatwerk subdomain
const maatwerkRouter = createBrowserRouter([
  {
    path: "/",
    element: <MaatwerkLayout company="MAATWERK" />,
    children: [
      {
        path: "/",
        element: <MaatwerkIntro module="PURCHASE" />,
      },
      {
        path: "/upload",
        element: <MaatwerkUpload />,
      },
      {
        path: "/results/:requestId",
        element: <MaatwerkResultaten />,
      },
      {
        path: "/questionnaire/:referenceId",
        element: <MaatwerkQuestionnaire />,
      },
    ],
  },
]);

// Then simplify the main App component
const App = () => {
  // Render placeholder for maatwerk subdomain
  if (isMaatwerkSubdomain) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={maatwerkRouter} />
      </ThemeProvider>
    );
  } else if (isWelocateSubdomain) {
    return (
      <ThemeProvider theme={welocateTheme}>
        <CssBaseline />
        <RouterProvider router={welocateRouter} />
      </ThemeProvider>
    );
  } else if (isDemoSubdomain) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={demoRouter} />
      </ThemeProvider>
    );
  }

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        // audience: "https://portal.checkyourterms.com/aud",
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "openid profile email",
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </Auth0Provider>
  );
};

export default App;
